{
  "point": "포인트",
  "points": "포인트",
  "credits": "크레딧",
  "loyaltyCredit": "Loyalty 크레딧",
  "statusPoints": "상태 포인트",
  "balancePoints": "지출 가능 포인트",
  "edit": "편집",
  "delete": "삭제",
  "copyOf": "사본 {value}개",
  "numberedCopyOf": "사본 {index}/{value}개",
  "total": "총계",
  "uplift": "인상",
  "approveBtn.label": "확인",
  "cancelBtn.label": "취소",
  "createBtn.label": "생성",
  "saveBtn.label": "저장",
  "searchBtn.label": "검색",
  "updateBtn.label": "업데이트",
  "applyBtn.label": "적용",
  "addNewPlanBtn.label": "플랜 추가",
  "launchPlanBtn.label": "플랜 시작",
  "toOverviewBtn.label": "개요로 이동",
  "collapseBtn.label": "축소",
  "extendBtn.label": "세부 정보 ",
  "updateAndSave.label": "업데이트 및 저장",
  "pleaseConfirmBtn.label": "확인",
  "closeBtn.label": "닫기",
  "resetBtn.label": "재설정",
  "confirmBtn.label": "확인",
  "status.inactive": "비활성",
  "status.active": "활성",
  "status.deactivated": "비활성화됨",
  "status.scheduled": "예약됨",
  "status.expired": "만료됨",
  "status.readyToUse": "사용 가능",
  "status.readyToLaunch": "실행 준비됨",
  "status.empty": "비어 있음",
  "status.activity.pending": "대기 중",
  "status.activity.confirmed": "확인됨",
  "status.activity.expired": "만료됨",
  "status.activity.canceled": "취소됨",
  "status.activity.removed": "제거됨",
  "status.default": "기본값",
  "action.promotion": "프로모션",
  "action.referral": "추천",
  "action.action": "행동",
  "tiers.numberOfPurchases.plural.zero": "{number}개 구매",
  "tiers.numberOfPurchases.plural.one": "{number}개 구매",
  "tiers.numberOfPurchases.plural.two": "{number}개 구매",
  "tiers.numberOfPurchases.plural.few": "{number}개 구매",
  "tiers.numberOfPurchases.plural.many": "{number}개 구매",
  "tiers.numberOfPurchases.plural.other": "{number}개 구매",
  "validity.unlimited": "무제한",
  "validity.limitedFromEarn.value.days.plural.zero": "{number}일",
  "validity.limitedFromEarn.value.days.plural.one": "{number}일",
  "validity.limitedFromEarn.value.days.plural.two": "{number}일",
  "validity.limitedFromEarn.value.days.plural.few": "{number}일",
  "validity.limitedFromEarn.value.days.plural.many": "{number}일",
  "validity.limitedFromEarn.value.days.plural.other": "{number}일",
  "validity.limitedFromEarn.value.weeks.plural.zero": "{number}주",
  "validity.limitedFromEarn.value.weeks.plural.one": "{number}주",
  "validity.limitedFromEarn.value.weeks.plural.two": "{number}주",
  "validity.limitedFromEarn.value.weeks.plural.few": "{number}주",
  "validity.limitedFromEarn.value.weeks.plural.many": "{number}주",
  "validity.limitedFromEarn.value.weeks.plural.other": "{number}주",
  "validity.limitedFromEarn.value.months.plural.zero": "{number}개월",
  "validity.limitedFromEarn.value.months.plural.one": "{number}개월",
  "validity.limitedFromEarn.value.months.plural.two": "{number}개월",
  "validity.limitedFromEarn.value.months.plural.few": "{number}개월",
  "validity.limitedFromEarn.value.months.plural.many": "{number}개월",
  "validity.limitedFromEarn.value.months.plural.other": "{number}개월",
  "days": "일",
  "dayInMonth": "일",
  "month": "월",
  "months.1": "1월",
  "months.2": "2월",
  "months.3": "3월",
  "months.4": "4월",
  "months.5": "5월",
  "months.6": "6월",
  "months.7": "7월",
  "months.8": "8월",
  "months.9": "9월",
  "months.10": "10월",
  "months.11": "11월",
  "months.12": "12월",
  "form.missingSettingsAlert": "저장하여 다음 단계로 계속하기 전에 모든 필수 정보를 입력했는지 확인하십시오.",
  "noResults.title": "결과를 찾을 수 없습니다.",
  "noResults.text": "검색어 \"{text}\"에 일치하는 결과가 없습니다.",
  "alertContainer.editModeAlert.message": "다음 버전의 Loyalty 플랜을 편집하고 있습니다. 변경 사항은 이 새 버전을 시작한 후 적용됩니다. ",
  "alertContainer.liveModeAlert.message.linkText": "자세히 알아보기",
  "alertContainer.liveModeAlert.message": "계층, 고정 혜택 및 추가 혜택을 편집하려면 Loyalty 관리에서 '업데이트 및 시작'을 선택한 후 '다음 버전 편집'으로 전환하십시오. {link}",
  "card.isRoadmap.text": "로드맵",
  "catalogSelector.tooManyResults.title": "이 검색에 대한 결과가 너무 많습니다. ",
  "catalogSelector.tooManyResults.text": "결과 범위를 좁히려면 더 구체적인 키워드로 다시 검색해 보십시오.",
  "catalogSelector.errorAlert": "오류가 발생했습니다. 다시 시도하십시오.",
  "catalogSelector.searchPlaceholder.byItem": "특정 제품을 검색하십시오.",
  "catalogSelector.searchPlaceholder.byCatOrBrand": "프로모션할 특정 브랜드나 범주를 선택하십시오.",
  "catalogSelector.checkAllItems.label": "모두 선택",
  "catalogSelector.showAllSelections.label": "선택한 항목만 표시하십시오.",
  "catalogSelector.cancelBtn.label": "닫기",
  "catalogSelector.saveBtn.label": "적용 및 저장",
  "catalogSelector.brands.plural.zero": "{number}개 브랜드",
  "catalogSelector.brands.plural.one": "{number}개 브랜드",
  "catalogSelector.brands.plural.two": "{number}개 브랜드",
  "catalogSelector.brands.plural.few": "{number}개 브랜드",
  "catalogSelector.brands.plural.many": "{number}개 브랜드",
  "catalogSelector.brands.plural.other": "{number}개 브랜드",
  "catalogSelector.category.plural.zero": "{number}개 범주",
  "catalogSelector.category.plural.one": "{number}개 범주",
  "catalogSelector.category.plural.two": "{number}개 범주",
  "catalogSelector.category.plural.few": "{number}개 범주",
  "catalogSelector.category.plural.many": "{number}개 범주",
  "catalogSelector.category.plural.other": "{number}개 범주",
  "catalogSelector.product.plural.zero": "{number}개 제품",
  "catalogSelector.product.plural.one": "{number}개 제품",
  "catalogSelector.product.plural.two": "{number}개 제품",
  "catalogSelector.product.plural.few": "{number}개 제품",
  "catalogSelector.product.plural.many": "{number}개 제품",
  "catalogSelector.product.plural.other": "{number}개 제품",
  "confirmNavDialog.discardChanges.text": "변경 사항을 반드시 저장하십시오. 이 페이지를 나가는 경우 저장되지 않은 변경 사항은 유실됩니다.",
  "confirmNavDialog.approveBtn.label": "확인",
  "confirmNavDialog.cancelBtn.label": "취소",
  "actionDashboard.overviewLinkText.referral": "추천 행동으로 이동",
  "actionDashboard.editLinkText": "프로그램 편집",
  "dashboardOptions.launchedAt": "프로그램 시작일: ",
  "dashboardOptions.currentlyShowingLabel": "현재 표시 중:",
  "dashboardOptions.viewLabel": "보기:",
  "masterActions.join.largeText": "Loyalty 가입",
  "masterActions.purchases.largeText": "구매",
  "status.inactive.tooltip": "설정이 완료되지 않았습니다.",
  "status.inactive.tooltip.proomotionEnded": "이 프로모션은 비활성 상태이므로 편집할 수 없습니다. 프로모션을 복사하거나 새 프로모션을 생성할 수 있습니다.",
  "status.inactive.tooltip.connectedToRewardPools": "상품권 풀 {name}이(가) {status} 상태입니다.",
  "status.inactive.tooltip.invalidPromotionRecurringDates": "프로모션 날짜를 확인합니다.",
  "status.readyToUse.tooltip.promotion": "프로모션을 사용할 준비가 되었습니다. 멤버의 지갑에 프로모션을 자동으로 표시하거나 Loyalty 토큰을 사용하여 캠페인 편집기에서 멤버에게 첨부할 수 있습니다.",
  "status.readyToUse.tooltip.attachable": "행동을 사용할 준비가 되었으며 Loyalty 토큰을 사용하여 캠페인 편집기를 통해 컨택트에 첨부할 수 있습니다.",
  "status.active.tooltip.promotion": "이 프로모션은 활성 상태이며 멤버가 사용할 수 있습니다.",
  "status.active.tooltip.attachable": "이 행동은 활성 상태입니다. 설정을 변경할 수 없습니다. 이 행동을 편집하려면 먼저 비활성화하고 지정된 만료일을 기다리십시오. 행동을 복사하고, 사본을 편집하고, 사본을 새 행동으로 시작할 수도 있습니다.",
  "status.active.tooltip.event": "이 행동은 활성 상태입니다. 이 행동을 혜택 또는 자동화 프로그램에 연결할 수 있습니다.",
  "status.deactivated.tooltip.promotion": "이 프로모션을 비활성화했으므로 더 이상 멤버에게 제공되지 않습니다.",
  "status.deactivated.tooltip.attachable": "이 행동을 비활성화했습니다. 이 행동을 편집하거나 삭제하려면 지정된 만료일을 기다려야 합니다. 행동을 복사하고, 사본을 편집하고, 사본을 새 행동으로 시작할 수도 있습니다.",
  "editorTypePopup.title": "편집기 유형 선택",
  "editorTypePopup.text": "독점 액세스 권한이 없는 고객에게는 차단 페이지가 표시됩니다. 사용자 정의 HTML 페이지를 생성하거나 템플릿 중 하나를 사용할 수 있습니다.",
  "editorTypePopup.options.html.text": "사용자 정의 HTML 페이지 생성",
  "editorTypePopup.options.template.text": "템플릿에서 페이지 생성",
  "fileInputField.uploadBtn.label": "업로드",
  "fileInputField.browseBtn.label": "찾아보기",
  "formStepsContainer.nextStep.text": "다음 단계",
  "formStepsContainer.prevStep.text": "이전 단계",
  "iconGallery.title": "Loyalty 아이콘 갤러리",
  "iconGallery.deleteDialog.headline": "이 아이콘을 삭제하시겠습니까?",
  "iconGallery.deleteDialog.content": "이 아이콘을 삭제하면 멤버에게 표시되지 않습니다. 이 아이콘이 행동이나 상품권에 연결되어 있지 않은지 확인하십시오.",
  "iconGallery.uploadResult.successMessage": "업로드 성공.",
  "iconGallery.searchInput.placeholder": "이름으로 아이콘 검색하십시오.",
  "iconGallery.fileUploader.tooltip": "<h3>업로드</h3><b>아이콘 업로드 요구 사항:</b></br>파일: SVG 또는 PNG</br>형식: 정사각형<br>최대 크기: 200x200픽셀 <br>최대 파일 크기: 100KB</br><sub>* 투명한 배경을 권장합니다.</sub>",
  "multiLangPopup.defaultNoticeText": "적합한 언어 설정이 없는 경우 정의된 기본 언어가 멤버에게 표시되는 기본 언어입니다.",
  "multiLangPopup.defaultTitle.currency": "통화 환산",
  "multiLangPopup.defaultTitle.language": "언어 번역",
  "multiMarketSelector.multiSelectField.placeholder": "-- 마켓 선택 --",
  "multiMarketSelector.selectField.placeholder": "-- 마켓 선택 --",
  "multiPlanSelect.label": "내 Loyalty 플랜 선택 ",
  "preLaunchPopup.conditions.plan.title": "플랜 설정",
  "preLaunchPopup.conditions.plan.text": "Loyalty 플랜 설정을 확인하여 모든 것이 제대로 설정되었고 멤버 약관과 일치하는지 확인하십시오.",
  "preLaunchPopup.conditions.tiers.title": "계층 및 혜택",
  "preLaunchPopup.conditions.tiers.text": "모든 멤버의 계층이 제대로 설정되었고 계층의 컨택트 배포가 전략과 일치하는지 확인하십시오.",
  "preLaunchPopup.conditions.rewards.title": "보상 풀",
  "preLaunchPopup.conditions.rewards.text": "모든 응답에 대해 충분한 상품권 코드를 업로드했고 모든 풀과 상품권 유효 기간이 올바로 정의되었는지 확인하십시오.",
  "preLaunchPopup.conditions.actions.title": "행동",
  "preLaunchPopup.conditions.actions.text": "행동이 사용하려는 모든 전략을 포함하고 모든 기본 행동을 활성화했는지 확인하십시오.",
  "preLaunchPopup.title": "Loyalty 플랜을 시작하시겠습니까?",
  "preLaunchPopup.text": "설정을 확인하여 Loyalty 플랜을 시작할 준비가 되었는지 확인하십시오.",
  "timeValidityInput.radioLabel.days": "일",
  "timeValidityInput.radioLabel.weeks": "주",
  "timeValidityInput.radioLabel.months": "개월",
  "ctaUrl": "CTA URL",
  "ctaText": "CTA 텍스트",
  "message": "메시지",
  "pageNotFound": "찾고 계신 페이지를 찾을 수 없습니다.",
  "externalEventSetup.title": "외부 Loyalty 이벤트",
  "externalEventSetup.name.label": "외부 이벤트 이름",
  "externalEventSetup.description.label": "설명",
  "externalEventSetup.description.tooltip": "설명은 내부용이며 Loyalty 이벤트를 관리하는 데 도움이 됩니다.",
  "pointsRatesFields.perDescriptor.points": "획득 - 단위 기간:",
  "catalog.item.type.category.name": "범주",
  "catalog.item.type.brand.name": "브랜드",
  "catalog.item.type.item.name": "제품",
  "catalog.item.type.itemId.name": "항목 ID",
  "exclusiveAccessOffers.options.fixedBenefit.title": "고정 혜택으로서의 액세스 권한",
  "exclusiveAccessOffers.options.additionalBenefits.title": "추가 혜택으로서의 액세스 권한",
  "exclusiveAccessOffers.options.action.title": "행동 보상으로서의 액세스 권한",
  "exclusiveAccessOffers.options.redemption.title": "포인트 액세스",
  "exclusiveAccessOffers.options.redemptionForFree.title": "무료 액세스",
  "accessValidityType.options.unlimited.name": "액세스는 무제한 기간 동안 유효합니다.",
  "accessValidityType.options.limitedFromEarn.name": "액세스는 멤버가 획득한 시점부터 제한된 기간 동안 유효합니다.",
  "accessValidityType.options.fixedDate.name": "액세스는 모든 멤버에게 미리 정의된 기간 동안 유효합니다.",
  "accessValidityType.options.disabled.fixedBenefit.name": "고정 혜택으로서의 액세스 사용 가능성 비활성화",
  "accessValidityType.options.disabled.additionalBenefit.name": "추가 혜택으로서의 액세스 사용 가능성 비활성화",
  "accessValidityType.options.disabled.reward.name": "행동에 대한 보상으로서의 액세스 사용 가능성 비활성화",
  "createOfModify.options.create.name": "오퍼 활성화",
  "createOfModify.options.create.tooltip": "새 오퍼를 활성화하면 활성 오퍼 규칙이 재설정되고 정의된 오퍼 기간 동안 모든 선택된 계층의 멤버가 사용할 수 있습니다.",
  "createOfModify.options.create.tooltip2": "새 오퍼를 활성화하면 활성 오퍼 제한이 재설정되고 정의된 오퍼 기간 동안 모든 선택된 계층의 멤버가 사용할 수 있습니다. ",
  "createOfModify.options.modify.name": "활성 오퍼 편집",
  "createOfModify.options.modify.tooltip": "활성 오퍼를 편집하는 경우 변경 사항은 이미 이 오퍼를 사용(상환)한 멤버에게 영향을 주지 않습니다.",
  "exclusiveAccessFormSteps.exclusiveAccessPoolSettings.title": "독점권 설정",
  "exclusiveAccessFormSteps.exclusiveAccessBlockingEditor.title": "차단 페이지",
  "exclusiveAccessFormSteps.redemptionValue.title": "액세스 및 오퍼",
  "exclusiveAccessFormSteps.EXCLUSIVE_ACCESS_VALIDITY.title": "활성화",
  "activityElementPointsText.loyalty": "{{points_name}}",
  "activityElementPointsText.pointsToSpend": "{{points_name}} 지출 가능",
  "activityElementPointsText.status": "상태{{points_name}}",
  "activityElementPointsText.cashback": "캐시백",
  "activityElementPointsText.cashback.name": "{{cashback_name}}",
  "voucherTypeText.one_time": "일회용 상품권",
  "voucherTypeText.yearly": "다중 사용 상품권",
  "exclusiveAccessTypeText.permanent": "영구적 독점 액세스",
  "exclusiveAccessTypeText.limitedTerm": "제한된 기간 독점 액세스",
  "mainTabs.dashboard.title": "대시보드",
  "mainTabs.actions.title": "행동",
  "mainTabs.rewards.title": "보상",
  "mainTabs.tiers.title": "계층",
  "mainTabs.loyaltyWallet.title": "Loyalty 지갑",
  "mainTabs.memberProfiles.title": "구성원 프로파일",
  "mainTabs.externalEvents.title": "외부 이벤트",
  "mainTabs.planSettings.title": "플랜 설정",
  "mainTabs.vouchers.title": "상품권",
  "mainTabs.exclusiveAccesss.title": "독점 액세스",
  "mainTabs.loyaltyManagement.title": "Loyalty 관리",
  "mainTabs.security.title": "Loyalty 구성",
  "actionTabs.purchases.title": "구매",
  "actionTabs.promotions.title": "프로모션",
  "actionTabs.engagements.title": "인게이지먼트",
  "actionTabs.events.title": "이벤트",
  "actionTabs.referral.title": "추천",
  "actionTabs.join.title": "Loyalty 가입",
  "tierTabs.tiers.title": "계층",
  "tierTabs.fixedBenefits.title": "고정 혜택",
  "tierTabs.additionalBenefits.title": "추가 혜택",
  "tierTabs.contactDistribution.title": "배포 차트",
  "managementTabs.accountSettings.title": "계정 설정",
  "managementTabs.languageAndCurrency.title": "언어 및 통화",
  "managementTabs.planSettings.title": "플랜 설정",
  "managementTabs.cashbackSettings.title": "캐시백 설정",
  "managementTabs.membershipSettings.title": "멤버권 설정",
  "managementTabs.updateAndLaunch.title": "업데이트 및 시작",
  "onboardingTabs.accountSettings.title": "플랜 생성",
  "onboardingTabs.activation.title": "활성화",
  "customerCalcPeriod.options.1.name": "지난 30일",
  "customerCalcPeriod.options.2.name": "지난 60일",
  "customerCalcPeriod.options.3.name": "지난 90일",
  "customerCalcPeriod.options.6.name": "지난 6개월",
  "customerCalcPeriod.options.12.name": "지난 12개월",
  "planType.options.points.name": "포인트 및 상환",
  "planType.options.points_and_benefits.name": "포인트 및 혜택",
  "planType.options.spend.name": "지출 및 혜택",
  "planType.options.points.tooltip": "단일 또는 여러 계층과 포인트 사용(상환)이 가능한 포인트 기반 플랜.",
  "planType.options.points_and_benefits.tooltip": "포인트 사용(상환)이 불가능한 여러 계층과 혜택이 있는 포인트 기반 플랜.",
  "planType.options.spend.tooltip": "포인트가 없지만 캐시백 옵션 규칙이 있는 단일 또는 여러 계층 및 혜택이 있는 지출 기반 플랜. 지출 기반 플랜에서는 하나의 통화만 관리합니다. 여러 통화를 관리하는 경우에는 각 통화에 대해 별도의 플랜을 관리해야 합니다.",
  "pointsAllocatopmDelay.options.1.name": "24시간",
  "pointsAllocatopmDelay.options.2.name": "48시간",
  "pointsAllocatopmDelay.options.3.name": "72시간",
  "pointsAllocatopmDelay.options.7.name": "7일",
  "pointsAllocatopmDelay.options.14.name": "14일",
  "pointsAllocatopmDelay.options.21.name": "21일",
  "pointsAllocatopmDelay.options.30.name": "30일",
  "pointsAllocatopmDelay.options.40.name": "40일",
  "tierCalculationType.options.endOfYear.name": " 계층 계산은 [X년]마다 12월 31일에 실행됩니다.",
  "tierCalculationType.options.endOfYear.tooltip": "계층은 [x년]마다 고정된 날짜에 계산됩니다. 상위 계층으로 업그레이드된 멤버는 정의된 기간 동안 계층 상태를 유지합니다.",
  "tierCalculationType.options.afterJoin.name": "계층 계산은 멤버가 계층에 진입한 날짜로부터 [X개월] 후에 수행됩니다.",
  "tierCalculationType.options.afterJoin.tooltip": "계층 계산 날짜는 멤버의 계층 진행 상황에 따라 달라질 수 있습니다. 상위 계층으로 업그레이드된 멤버는 적어도 정의된 기간 동안 계층 상태를 유지합니다.",
  "tierCalculationType.options.endOfYear.spend.tooltip": "계층이 계산되면 Loyalty 크레딧은 재설정되지만 멤버는 다음 계산 전까지 계층 상태를 유지합니다.",
  "tierCalculationType.options.noDropout.name": "계층이 계산되어 있지 않습니다. 멤버는 이 계층에 머무르기 위한 요구 사항을 충족할 필요가 없습니다.",
  "tierCalculationType.options.noDropout.tooltip": "포인트는 계층 업그레이드용으로만 수집됩니다.",
  "statusPointsExpirationType.options.tierCalc.name": "상태 포인트는 계층 계산 날짜에 만료되고 재설정됩니다.",
  "statusPointsExpirationType.options.tierCalc.tooltip": "포인트가 계산되면 재설정되지만, 멤버는 다음 계산 전까지 계층 상태를 유지합니다.",
  "statusPointsExpirationType.options.fromEarn.name": "상태 포인트는 만료되고 멤버가 포인트를 획득한 날짜로부터 [X개월]마다 재설정됩니다.",
  "statusPointsExpirationType.options.fromEarn.tooltip": "계층이 계산될 때 해당 날짜의 유효한 포인트만 계산됩니다. 멤버는 상태를 유지하거나 더 낮은 계층으로 떨어집니다.",
  "statusPointsExpirationType.options.never.name": "상태 포인트는 만료되지 않습니다.",
  "loyaltyCreditExpirationType.options.tiersCalc.name": "Loyalty 크레딧은 계층이 계산된 날짜에 만료되고 재설정됩니다.",
  "loyaltyCreditExpirationType.options.tiersCalc.tooltip": "Loyalty 크레딧이 계산되면 Loyalty 크레딧은 재설정되지만 멤버는 다음 계산 전까지 해당 계층 상태를 유지합니다.",
  "loyaltyCreditExpirationType.options.fromEarn.name": "Loyalty 크레딧은 만료되며 멤버가 크레딧을 획득한 날짜로부터 [X개월]마다 재설정됩니다.",
  "loyaltyCreditExpirationType.options.fromEarn.tooltip": "계층이 계산될 때에는 해당 날짜의 유효한 Loyalty 크레딧만 계산됩니다. 멤버는 상태를 유지하거나 더 낮은 계층으로 떨어집니다.",
  "optIn.options.invitation.name": "모든 컨택트는 Loyalty 플랜에 가입하도록 초대됩니다.",
  "optIn.options.automatic.name": "모든 컨택트는 자동으로 Loyalty 멤버가 됩니다.",
  "historicalBalancePoints.options.keep.name": "지출 포인트로 보상하십시오.",
  "historicalBalancePoints.options.keep.tooltip": "이 옵션은 멤버에게 포인트를 보상으로 사용(상환)하도록 장려합니다.",
  "historicalBalancePoints.options.remove.name": "지출 포인트로 보상하지 마십시오.",
  "historicalBalancePoints.options.remove.tooltip": "지출 포인트가 재설정되고 멤버는 사용(상환)할 새 포인트를 획득해야 합니다.",
  "currencyIdentifierSigh.options.symbol.name": "통화 기호",
  "currencyIdentifierSigh.options.symbol.tooltip": "예: $500",
  "currencyIdentifierSigh.options.code.name": "ISO 통화 코드",
  "currencyIdentifierSigh.options.code.tooltip": "예: 500USD",
  "currencyIdentifierSigh.options.none.name": "식별자 없음",
  "formStepRewards.options.poolSettings.title": "풀 설정",
  "formStepRewards.options.uploadFile.title": "파일 업로드",
  "formStepRewards.options.redemptionValue.title": "오퍼 설정",
  "formStepRewards.options.validity.title": "유효 기간",
  "specialTiers.redemptopmSettings.all.name": "모든 계층에 동일한 설정을 사용하십시오. 개별 계층 값은 재정의됩니다.",
  "voucherValidityType.options.unlimited.name": "상품권은 무제한 기간 동안 유효합니다.",
  "voucherValidityType.options.limitedFromEarn.name": "상품권은 멤버가 상품권을 획득한 시점부터 제한된 기간 동안 유효합니다.",
  "voucherValidityType.options.fixedDate.name": "상품권은 모든 멤버에게 미리 정의된 기간 동안 유효합니다.",
  "redemptionLimit.options.noLimit.name": "이 오퍼를 정기적으로 멤버에게 자동으로 표시합니다.",
  "redemptionLimit.options.noLimit.tooltip": "계층에 대한 토글을 활성화하면 상환(사용) 오퍼가 상환 제한 없이 Loyalty 지갑에 표시됩니다.",
  "redemptionLimit.options.limitMember.name": "이 오퍼에 대해 정의된 기간 동안 각 멤버가 상품권을 사용(상환)할 수 있는 횟수를 선택하십시오.",
  "exclusiveAccessExclusivityType.options.name.fixed": "영구 독점",
  "exclusiveAccessExclusivityType.options.name.limitedTerm": "기간 제한된 독점",
  "exclusiveAccessExclusivityType.options.name.limited": "제한된 독점",
  "editorContentTextDefaultValues.tag": "독점 액세스",
  "editorContentTextDefaultValues.firstHeader": "<strong>조기 블랙 프라이데이</strong>",
  "editorContentTextDefaultValues.secondHeader": "<strong>세일</strong>",
  "editorContentTextDefaultValues.middleText": "충성 멤버를 위한 단독 블랙 프라이데이 딜입니다. 놓치지 마세요. 지금 Loyalty 플랜에 가입하세요!",
  "editorContentTextDefaultValues.actionTopText": "아직 멤버가 아니십니까? Loyalty 플랜에 가입하여 보상을 받으세요.",
  "editorContentTextDefaultValues.leftButton": "Loyalty 가입",
  "editorContentTextDefaultValues.rightButton": "다른 시간",
  "editorContentTextDefaultValues.actionBottomText": "<span>이미 멤버이십니까? <u>로그인</u>하십시오.</span>",
  "editorContentTextDefaultValues.middleText.mobile": "충성 고객을 위한 단독 딜입니다. 놓치지 마세요. 지금 Loyalty 플랜에 가입하세요!",
  "editorContentTextDefaultValues.actionTopText.mobile": "아직 멤버가 아니십니까? Loyalty 프로그램에 가입하세요.",
  "accessUrlType.options.exactUrl.name": "다음 페이지를 차단하고 독점 액세스 권한을 제공하십시오.",
  "accessUrlType.options.startsWithUrl.name": "다음 URL로 시작하는 모든 페이지를 차단하고 독점 액세스 권한을 제공하십시오.",
  "formStepsContainer.tierSettings.title": "계층 설정",
  "formStepsContainer.purchaseBenefits.title": "구매 혜택",
  "formStepsContainer.visibility.title": "표시",
  "tierDropout.options.yes.name": "예, 이 계층은 계산되며 멤버는 이 계층에 머무르기 위한 요구 사항을 충족해야 합니다.",
  "tierDropout.options.no.name": "아니요, 이 계층에서 탈퇴하는 시나리오는 없습니다.",
  "fixedBenfitType.options.oneTimeVoucher.name": "일회성 상품권",
  "fixedBenfitType.options.fixedYearlyVoucher.name": "고정 연간 상품권(다중 사용 코드 필요).",
  "fixedBenfitType.options.eventAction.name": "이벤트",
  "fixedBenfitType.options.exclusiveAccess.name": "독점 액세스",
  "fixedBenfitType.options.custom.name": "사용자 정의(귀하가 독립적으로 제공)",
  "fixedBenfitType.options.fixedYearlyVoucher.additional.name": "다중 사용 상품권(다중 사용 코드 필요).",
  "tierTypeOptions.regular.name": "포인트 기반",
  "tierTypeOptions.invite.name": "초대 전용",
  "tierTypeOptions.invite.tooltip.learnMoreLinkText": "자세히 알아보기",
  "tierTypeOptions.invite.tooltip": "초대된 멤버나 유료 멤버만 이 계층에 속할 수 있습니다. 결제 및 멤버권은 귀하 측에서 관리하십시오. 이 계층에 멤버를 추가하려면 Loyalty API 또는 구성원 프로파일을 사용하십시오. {learnMoreLink}.",
  "tierTypeOptions.spend.name": "지출 기반",
  "exclusiveAccess.cardLabels.permanent": "영구적",
  "exclusiveAccess.cardLabels.limtedTerm": "기간 제한",
  "cards.filterBar.moreFiltersButton": "추가 필터",
  "catalogSelector.selected.single": "{items}개 선택됨",
  "catalogSelector.selected.multiple": "{items} 및 {lastItems}이(가) 선택됨",
  "iconGallery.uploadResult.failMessage": "업로드 중에 문제가 발생했습니다. 파일이 요구 사항을 충족하는지 확인하십시오. \n{showFileList,select,true{{total}개 중 {failed}개 실패: {failedDetails}} other{{failedDetails}}} ",
  "pointsRatesFields.perDescriptor.spend": "모두에 대해",
  "activityElementMultiuplyPointsText.double": "2중",
  "activityElementMultiuplyPointsText.triple": "3중"
}
